/**
 * Client-side Brands directory filter (mega-menu + mobile drawer).
 * Filters [data-brand-item] inside the nearest [data-brands-panel].
 * Hides empty A–Z columns; announces match counts via aria-live.
 */
(function () {
  function normalize(str) {
    return String(str || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();
  }

  function filterPanel(panel, query) {
    const q = normalize(query);
    const items = panel.querySelectorAll('[data-brand-item]');
    let visible = 0;

    items.forEach((el) => {
      const name = normalize(el.getAttribute('data-brand-name') || el.textContent);
      const match = !q || name.indexOf(q) !== -1;
      el.hidden = !match;
      if (match) visible += 1;
    });

    panel.querySelectorAll('[data-brands-az-col]').forEach((col) => {
      const anyVisible = col.querySelector('[data-brand-item]:not([hidden])');
      col.hidden = !!(q && !anyVisible);
    });

    /* "All Brands" always stays available */
    panel.querySelectorAll('[data-brand-item-static]').forEach((el) => {
      el.hidden = false;
      if (q) {
        const col = el.closest('[data-brands-az-col]');
        if (col && !col.querySelector('[data-brand-item]:not([hidden])')) {
          col.hidden = false;
        }
      }
    });

    const status = panel.querySelector('[data-brands-search-status]');
    const empty = panel.querySelector('[data-brands-search-empty]');
    if (status) {
      if (!q) {
        status.textContent = '';
      } else if (visible === 0) {
        status.textContent = 'No brands match your search.';
      } else if (visible === 1) {
        status.textContent = '1 brand found.';
      } else {
        status.textContent = visible + ' brands found.';
      }
    }
    if (empty) {
      empty.hidden = !(q && visible === 0);
    }

    return visible;
  }

  function bindSearch(root) {
    if (!root || root.dataset.brandsSearchBound === '1') return;
    root.dataset.brandsSearchBound = '1';

    const input = root.querySelector('[data-brands-search-input]');
    const panel = root.closest('[data-brands-panel]');
    if (!input || !panel) return;

    const run = () => filterPanel(panel, input.value);

    input.addEventListener('input', run);
    input.addEventListener('search', run);

    /* Don't bubble keys that might close the menu */
    input.addEventListener('keydown', (e) => {
      e.stopPropagation();
      if (e.key === 'Escape') {
        input.value = '';
        run();
        input.blur();
      }
    });

    /* Reset filter when Brands panel closes; keep input focusable (no forced autofocus) */
    const details = root.closest('details');
    if (details) {
      details.addEventListener('toggle', () => {
        if (!details.open) {
          input.value = '';
          run();
        }
      });
    }
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-brands-search]').forEach(bindSearch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
